import { render, staticRenderFns } from "./PaintPDF.vue?vue&type=template&id=2460f0b9&scoped=true&"
import script from "./PaintPDF.vue?vue&type=script&lang=js&"
export * from "./PaintPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2460f0b9",
  null
  
)

export default component.exports